import React, { useState } from 'react';
import { LogoButton, NavigationBarContainer, Title, Details, Host } from './styles';
import { VisibilityConfig } from '../../../VisibilityConfig/VisibilityConfig';
import { Button, Space } from 'antd';
import { ShareBox } from '../../../ShareBox';
import { AccountSelector } from '../../../AccountSelector/AccountSelector/AccountSelector';
import { useNavigate } from 'react-router-dom';
import { PublicRecapBadge } from '../../../PublicRecapBadge';
import { EditableTitle } from '../EditableTitle/index';
import { useRecapManagement } from '../../../../../recapv2/recap-management/hook';
import { MeetingTypeSelector } from '../../../../../home/tabs/UpcomingsTab/components/MeetingTypeSelector';
import logo from '../../../../../../assets/svg/brandingLogo.svg';
import arrow from '../../../../../../assets/svg/arrow-left.svg';
import { format, parseISO } from 'date-fns';
import { CalendarOutlined } from '@ant-design/icons';

const recapFormatDateShort = (startTime: string, endTime: string): string => {
  const startDate = parseISO(startTime);
  const endDate = parseISO(endTime);

  const formattedStartDate = format(startDate, 'eeee, MMMM d, yyyy h:mma');
  const formattedEndDate = format(endDate, 'h:mma');

  // if it ends the next day (which will not happen that often) this will return something like Friday, June 23, 2023 11:00PM - 01:00AM (and it is implied that ended the next day)
  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const NavigationBar: React.FC = () => {
  const { isPublic, type, started, ended, scheduledStartDate, host, id, permissions, isDemo } =
    useRecapManagement();

  const navigate = useNavigate();

  const [hoveredLogo, setHoveredLogo] = useState(false);

  const startDate = scheduledStartDate || started || new Date();
  const endedDate = ended || new Date();

  const startTime = startDate.toISOString();
  const endTime = endedDate.toISOString();

  const goToRecaps = () => {
    navigate('/meetings/recaps');
  };

  return (
    <NavigationBarContainer>
      <Space>
        <LogoButton
          onClick={goToRecaps}
          onMouseEnter={() => setHoveredLogo(true)}
          onMouseLeave={() => setHoveredLogo(false)}
        >
          {hoveredLogo ? <img src={arrow} /> : <img src={logo} />}
        </LogoButton>

        <Title>
          <EditableTitle />
          <Details>
            <>{recapFormatDateShort(startTime, endTime)}</>
            <div style={{ paddingLeft: '16px', paddingRight: '16px' }}>|</div>
            <div style={{ fontFamily: 'Cera Pro Medium' }}>Host</div>
            <Host>: {host}</Host>
          </Details>
        </Title>
      </Space>

      <Space style={{ paddingRight: '24px' }}>
        {isPublic ? (
          <Space>
            <PublicRecapBadge />
          </Space>
        ) : (
          <>
            <AccountSelector />
            <MeetingTypeSelector
              meetingType={type}
              eventId={id}
              size="middle"
              hasPermissions={permissions.canChangeMeetingTypes}
            />
            <ShareBox />
            {isDemo && (
              <Button
                type="primary"
                onClick={() => navigate('/past-meetings')}
                icon={<CalendarOutlined />}
              >
                Take me to my Dashboard
              </Button>
            )}
            <VisibilityConfig />
          </>
        )}
      </Space>
    </NavigationBarContainer>
  );
};
